import { faUserPlus } from '@fortawesome/pro-regular-svg-icons'
import { Button, Text } from '@/ui'
import { TextColors, TypographyStyles } from '@/styles'
import { ADVISER_ASSISTANT_NAME } from '../lib/constants'
import type { OperatorIdentity } from '../lib/types'
import { Leaf } from './Leaf'
import { OperatorAvatar } from './OperatorAvatar'

interface ComposerOwnerBarProps {
  /** The operator a plain message reaches, or null while nobody holds the conversation. */
  holder: OperatorIdentity | null
  /** A case that is neither resolved nor back with Haven. */
  caseIsLive: boolean
  /** True while the composer itself is locked, so the offer cannot outrun it. */
  disabled?: boolean
  onAskPerson: () => void
}

const PILL =
  'flex w-fit max-w-full items-center gap-2 rounded-full border border-neutral-200 bg-neutral-0 py-0.5 pl-1 pr-2'

export const ComposerOwnerBar = ({
  holder,
  caseIsLive,
  disabled = false,
  onAskPerson,
}: ComposerOwnerBarProps) => {
  // An unassigned open case has nobody to name, and the header already reads
  // "Waiting on Heard" directly above.
  if (!holder && caseIsLive) return null

  if (holder) {
    return (
      <div className={`mb-2 ${PILL}`}>
        <OperatorAvatar operator={holder} className="size-5 text-[10px]" />
        <Text
          variant={TypographyStyles.LABEL_XS}
          color={TextColors.HEADER}
          className="truncate"
        >
          Replying to {holder.friendlyName}
        </Text>
      </div>
    )
  }

  return (
    <div className="mb-2 flex items-center justify-between gap-3">
      <div className={PILL}>
        <span className="flex size-5 shrink-0 items-center justify-center rounded-full bg-moss-50">
          <Leaf size={12} />
        </span>
        <Text
          variant={TypographyStyles.LABEL_XS}
          color={TextColors.HEADER}
          className="truncate"
        >
          {ADVISER_ASSISTANT_NAME} is answering
        </Text>
      </div>
      <Button
        type="button"
        variant="secondary"
        size="sm"
        iconLeft={faUserPlus}
        disabled={disabled}
        onClick={onAskPerson}
        className="shrink-0 rounded-full"
      >
        Ask a person
      </Button>
    </div>
  )
}
